import { render } from "./UsuarioPage.vue?vue&type=template&id=3db43a11&scoped=true"
import script from "./UsuarioPage.vue?vue&type=script&lang=js"
export * from "./UsuarioPage.vue?vue&type=script&lang=js"

import "./UsuarioPage.vue?vue&type=style&index=0&id=3db43a11&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db43a11"]])

export default __exports__